// Small math helpers. Keep hot-path helpers allocation-free (operate on numbers,
// not objects) - see plan §6 performance rules.

export const clamp = (v: number, min: number, max: number): number =>
  v < min ? min : v > max ? max : v;

export const lerp = (a: number, b: number, t: number): number => a + (b - a) * t;

/** Squared distance - prefer over `length` in hot loops to skip the sqrt. */
export const dist2 = (ax: number, ay: number, bx: number, by: number): number => {
  const dx = ax - bx;
  const dy = ay - by;
  return dx * dx + dy * dy;
};

export const len = (x: number, y: number): number => Math.hypot(x, y);

/** Wrap an angle to (-PI, PI]. */
export const wrapAngle = (a: number): number => {
  while (a <= -Math.PI) a += Math.PI * 2;
  while (a > Math.PI) a -= Math.PI * 2;
  return a;
};
